import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

// Body must be FormData: 'file' (required), 'mime_type' (required), 'filename' (optional).
type MutationPayload = FormData;

type MutationResponse = {
  status: number;
  data: { id?: string; [key: string]: unknown };
};

export const useUploadMediaMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred during WhatsApp media upload',
    endpoint: '/api/admin/whatsapp/media',
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
